// extracted by mini-css-extract-plugin
export default {"smallButton":"buttonFileInput_smallButton__V8CD+"};